// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"6213":"chunk.owl-carousel","8668":"chunk.owl-carousel-navigation"}[chunkId] + ".js";
};